// extracted by mini-css-extract-plugin
module.exports = {"listicon":"listicon--3wb1j"};